
import React, { useState, useEffect } from 'react';

import Dashboardnavbar from '../../layout/Dashboardnavbar';

import TableDesignclient from './Tabledesignclient';
import ClientTable from './ClientName';

const Clientmain = () => {

    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {

            case 1:
                return 'Client Name';
            case 2:
                return 'Client Details';

            default:
                return 'Client Name';
        }
    };


    return (
        <>
            {/* <Dashboardnavbar url="clients" name={"clients"} /> */}
            <Dashboardnavbar name={getSelectedTitle()} url="Client Management" />
             <div className='content-tabs'>
                <div className="toggle-button-area" style={{ padding: "34px 30px" }}>
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        Client Name
                    </button>

                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        Client Details
                    </button>
                </div>
            </div>

             <div className="content-tabs">
                {toggleState === 1 ? <ClientTable /> : null}
                {toggleState === 2 ? <TableDesignclient /> : null}
                
             </div>
            
        </>
    );
};


export default Clientmain